import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const schema = z.object({
  type: z.string().optional(),
  returnUrl: z.string().optional()
})

export const salesDataBankSourceOverrideRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `bank-source-override/$mrId/$licenseId`,
    component: lazyRouteComponent(() => import('./BankSourceOverride')),
    validateSearch: (search) => schema.parse(search)
  })
